import { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min";
import "./site.css";
import "./v2_remake.css";

import { HeadlessReportPage } from "./containers/HeadlessReportPage";
import { App } from "./App";
import { SpinnyThingy } from "./components/Misc/SpinnyThingy";
import { PolicyPage } from "./containers/PolicyPage";


const root = createRoot(document.getElementById("root")!);

root.render(
  <Suspense fallback={(
    <SpinnyThingy />
    )}
  >
    <Router>
      <Switch>
        <Route path="/policy" render={() => <PolicyPage />} />
        <Route exact path="/headless/:id" component={HeadlessReportPage} />
        <Route
          exact
          path=""
          component={App}
        />
      </Switch>
    </Router>
  </Suspense>,
);
